import { Flex, Container, Card, styled } from '@grupoboticario/flora-react';

export const styles = {
  Challenges: styled(Container, {
    display: 'flex',
    gap: '$2',
    justifyContent: 'center',
    padding: '0',
    flexWrap: 'wrap',
  }),

  ChallengesCard: styled(Card, {
    backgroundColor: '$backgroundSecondary',
    width: '100%',

    '&[data-complete="true"]': {
      backgroundColor: '$backgroundTertiary',
    },

    '@tablet': {
      width: 'calc(100% / 3 - $4)',
    },
  }),

  ChallengesWrapper: styled(Flex, {
    alignItems: 'center',
    flexDirection: 'column',
    gap: '$4',
    padding: '$12 0 0 0',
  }),

  ResellerProgress: styled(Card, {
    backgroundColor: '$backgroundSecondary',
    display: 'flex',
    flexDirection: 'column',
    gap: '$4',
    padding: '$4',
    textAlign: 'center',
    width: '100%',

    '@tablet': {
      maxWidth: 'calc($22 * 5)',
    },
  }),

  RemainingValue: styled(Card, {
    backgroundColor: '$backgroundSecondary',
    padding: '$3 $4',
  }),

  LastUpdate: styled(Flex, {
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '$3 $0',
  }),

  TotalCard: styled(Card, {
    padding: '$4',
    marginTop: '$10',
    border: '1px solid $backgroundSecondary',
    borderRadius: 'none',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    '@tablet': {
      maxWidth: 'calc($22 * 5)',
    },
  }),

  Wrapper: styled(Flex, {
    gap: '$4',
    padding: '0',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',

    '> ::before, * ::before': {
      boxShadow: 'initial',
    },
  }),
};

export default styles;
